import ApplicationSerializer from './application';

export default class Payment extends ApplicationSerializer {
  serializeBelongsTo(snapshot, json, relationship) {
    if (relationship.key !== 'stripePaymentInstrument') {
      return super.serializeBelongsTo(...arguments);
    }

    if (snapshot.attr('customCardToken')) {
      return;
    }

    const belongsTo = snapshot.belongsTo('stripePaymentInstrument');
    if (!belongsTo) {
      return;
    }

    if (belongsTo.modelName === 'card' && belongsTo.isNew && this._shouldEmbedCard(snapshot)) {
      this._embedCardAttributes(belongsTo, json, snapshot.adapterOptions);
      return;
    }

    if (!belongsTo.isNew) {
      return super.serializeBelongsTo(...arguments);
    }
  }

  _shouldEmbedCard(snapshot) {
    return snapshot.adapterOptions?.embed?.includes('card');
  }

  _embedCardAttributes(belongsTo, json, adapterOptions) {
    const serialized = belongsTo.serialize({
      includeId: true,
      adapterOptions,
    });

    json.attributes = json.attributes || {};
    json.attributes.cardAttributes = Object.assign(
      { id: serialized.data.id },
      serialized.data.attributes
    );
    this._addBelongsToIds(belongsTo.record, json.attributes.cardAttributes);
  }
}
